import { useMemo } from "react";
import { ParameterConflict } from "store/api/generatedApi";
import { ChemistryRowWarnings } from "components/materialChemistry/types";
import { ConflictReasons } from "./ConflictReasons";
import { indexChemistryConflicts } from "./parameterConflicts";

export const useChemistryRowWarnings = ({
  conflicts,
  chefGroupNameById,
  limitLabelBySignature,
}: {
  conflicts: ParameterConflict[];
  chefGroupNameById: Record<number, string>;
  limitLabelBySignature: Record<string, string>;
}): ChemistryRowWarnings =>
  useMemo(
    () =>
      new Map(
        [...indexChemistryConflicts(conflicts)].map(([key, rowConflicts]) => [
          key,
          <ConflictReasons
            key={key}
            conflicts={rowConflicts}
            chefGroupNameById={chefGroupNameById}
            limitLabelBySignature={limitLabelBySignature}
          />,
        ])
      ),
    [conflicts, chefGroupNameById, limitLabelBySignature]
  );
